// Create a separate ErrorBoundary component
// ErrorBoundary.js
import React from 'react';
import NotFoundPage from '../NotFoundPage'; // Adjust path as needed

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    console.log(error, 'ErrorBoundary getDerivedStateFromError called');
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    console.error("Caught error:", error, errorInfo);
  }

  render() {
    console.log('ErrorBoundary render method called');
    if (this.state.hasError) {
      // Force the NotFoundPage to render in error mode
      return <NotFoundPage isError={true} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;